import { Box, Center, Text } from "native-base";
import React from "react";

import Breadcrumb from "@/components/atoms/Breadcrumb";
import Container from "@/components/organisms/Container";
import ProductList from "@/components/organisms/ProductList";
import WebHeader from "@/components/organisms/WebHeader";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useStoreHalls } from "@/hooks/domain/storeHall";
import { useStoreById } from "@/hooks/domain/stores";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

import { CategoryProductListScreenProps } from "./types";

const CategoryProductListWeb = ({
  category,
  products,
  isLoading,
  isLoadingMore,
  onGoBack,
  onSelectProduct,
  onViewMore,
}: CategoryProductListScreenProps) => {
  const { navigate } = useAppNavigation<HomeNavigation>();

  const { data: store } = useStoreById(category?.estabelecimento, {
    enabled: !!category?.estabelecimento,
  });

  const { data: hallList } = useStoreHalls(store?._id, {
    enabled: !!store?._id,
  });

  const onSelectHall = (hallId: string) => {
    navigate("hallCategoryList", { hallId });
  };

  return (
    <Container
      px="5%"
      Header={
        <WebHeader
          title={store?.nome_fantasia}
          searchInStoreId={store?._id}
          badgeTitle={category?.nome}
          badgeList={hallList}
          onPressBack={onGoBack}
          onSelectBadge={(item) => onSelectHall(item?._id)}
        />
      }>
      <Box pt="4">
        <Breadcrumb
          routes={[
            { title: "Home", routeName: "home" },
            {
              title: store?.nome_fantasia,
              routeName: "storeHome",
              params: { storeId: store?._id },
            },
            { title: category?.nome, routeName: "categoryProductList" },
          ]}
        />
      </Box>
      <Center py="8">
        <Text fontSize="3xl" color="text.600" bold>
          {category?.nome}
        </Text>
      </Center>
      <ProductList
        data={products}
        isLoading={isLoading}
        isLoadingMore={isLoadingMore}
        onLoadMore={onViewMore}
        onSelect={onSelectProduct}
      />
    </Container>
  );
};

export default CategoryProductListWeb;
